import { App } from '~/app';
import { isMobile } from '~/framework/helpers/browser/media-query';
import { scrollToCoord } from '~/framework/utils/scroll';


export default (app: App) => {    
    app.logger.debug('[Stockland FE] Initialise Stockland Feature Links and Image Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            setTimeout(() =>{
                mountFeatureLinksAndImages(listeners)
            }, 300)
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Feature Links and Image component', error);
        });

    return function destroyFreeTextQuickLinks() {
        unMountFeatureLinksAndImages(listeners)

        app.logger.debug('[DXA] Feature Links and Image component destroyed');
    };


    function mountFeatureLinksAndImages(
        listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
        root: HTMLElement | null = null) {
        let rootNode: Document | HTMLElement = document;
        if (root) rootNode = root;

        const featuredLinks = rootNode.querySelectorAll<HTMLElement>(".feature-link-image-parent");

        for (const featuredLinkBlock of featuredLinks) {
            const buTitles = featuredLinkBlock.querySelectorAll<HTMLElement>(".bu-title");
            const scrollAnchor = featuredLinkBlock.querySelector<HTMLElement>(".overlap-elements-mobile-scroll-anchor");

            const buTitleClick = (buTitlesParameter:NodeListOf<HTMLElement>, eventTarget: EventTarget | undefined, scroll: boolean) => {
                const currentTitle = eventTarget as HTMLElement;

                if(!currentTitle.classList.contains('active-link')) {
                    for (const buTitle of buTitlesParameter){
                        // Unset all active links
                        buTitle.classList.remove('active-link');
                    }

                    currentTitle.classList.add('active-link')

                    const textDivs = featuredLinkBlock.querySelectorAll<HTMLElement>('.text-div')
                    const buButtonDivs = featuredLinkBlock.querySelectorAll<HTMLElement>('.bu-button-div')
                    const buImages = featuredLinkBlock.querySelectorAll<HTMLElement>('.bu-image')
					
                    for(const buButtonDiv of buButtonDivs){
                        if (buButtonDiv.classList.contains('active')){
                            buButtonDiv.classList.remove('active');
                        }
                    }

                    for(const textDiv of textDivs){
                        if (textDiv.classList.contains('active')){
                            textDiv.classList.remove('active');
                        }
                    }

                    for(const buImage of buImages){
                        if (buImage.classList.contains('active')){
                            buImage.classList.remove('active');
                        }
                    }

                    const currentId = Number.parseInt((/\d+/.exec(currentTitle?.id))?.[0] ?? "0");

                    textDivs[currentId].classList.add('active')
                    buButtonDivs[currentId].classList.add('active')
                    buImages[currentId].classList.add('active')
                }

                if (scroll && isMobile() && scrollAnchor) {
                    const rect = scrollAnchor.getBoundingClientRect();
                    const top = rect.top + window.scrollY;
                    scrollToCoord(top);
                }
            }
		
	
            for (const buTitle of buTitles) {
                buTitle.addEventListener('click', (event: Event) => buTitleClick(buTitles, event.target!, true));
                listeners.push([buTitle, "click", (event: Event) => buTitleClick(buTitles, event.target!, true)])

                if (buTitle.innerHTML == buTitles[0].innerHTML) {
                    // Piggy back on our click events to make the first item visible
                    buTitleClick(buTitles, buTitle, false)
                }
            }
        }
    }


    function unMountFeatureLinksAndImages(
        listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
    ) {
        for (const [element, event, listener] of listeners) {
            element.removeEventListener(event, listener);
        }
    }
}